import {NOT_AVAILABLE_FILTERS as sharedNotAvailableFilters} from '../common/searchSave.js'
import {
  BUGGIES_CATEGORY1_ID,
  CLASSICS_CATEGORY1_ID,
  FILTER_NAMES,
  MINIMOTOS_CATEGORY1_ID,
  MOTOS_CATEGORY1_ID,
  QUADS_CATEGORY1_ID
} from './ads.js'

export const FREQUENCY_NOTIFICATION_DAILY = 'DAILY'
export const FREQUENCY_NOTIFICATION_REALTIME = 'REAL_TIME'
export const frequencyNotificationData = {
  [FREQUENCY_NOTIFICATION_REALTIME]: {
    activeRealtimePush: true,
    activeRealtimeEmail: true
  },
  [FREQUENCY_NOTIFICATION_DAILY]: {
    activeRealtimePush: false,
    activeRealtimeEmail: false
  }
}

/**
 * @exports ALERTS_FILTERS_MAP
 */
export const ALERTS_FILTERS_MAP = {
  [MOTOS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.BODY_TYPE_CATEGORY,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.KMS,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.FUEL_TYPE,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.BODY_TYPE_CATEGORY,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.FUEL_TYPE,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [QUADS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.KMS,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [BUGGIES_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.YEARS,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.KMS,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [MINIMOTOS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.SEARCH_TEXT,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.SEARCH_TEXT,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [CLASSICS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.SEARCH_TEXT,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PHOTO
    ]
  ]
}

// Define only the paths that are different from the common ones
export const NOT_AVAILABLE_FILTERS = [...sharedNotAvailableFilters]
